<template>
    <v-row no-gutters align="start" justify="center" class="mt-3">
        <div class="bento-container">


            <!-- Socials Section -->
            <div 
            class="bento-item-small"
                id="socials"
            >
                <slot name="socials"></slot>
            </div>


            <!-- Todas las tarjetas en orden -->
            <HarmonyCard
                v-for="(card, index) in allCards"
                :key="card.key"
                :class="getBentoItemClass(index)"
                :cardData="card"
                :settings="settings"
                :isEditor="isEditor"
                :userName="userName"
                :backendUrl="backendUrl"
                :incompleteConfigurations="incompleteConfigurations"
                :disableMargins="true"
                @edit-card="$emit('edit-card', $event)"
                @navigate-to-card="$emit('navigate-to-card', $event)"
                @save-settings="$emit('save-settings')"
            />

            <!-- WhatsApp/Email Section -->
            <div 
                v-if="shouldShowWppEmail"
                class="bento-item bento-item-small bento-wpp-email"
            >
                <slot name="wpp-email"></slot>
            </div>

            <!-- Add Card Buttons -->
            <div 
                v-if="isEditor"
                class="bento-item bento-item-small bento-add-card"
                @click="$emit('add-card')"
            >
                <div class="add-card-content">
                    <v-icon center color="#C9C9C9" size="60px">
                        mdi-plus
                    </v-icon>
                    <p class="add-card-text">Agregar Tarjeta</p>
                </div>
            </div>
        </div>
    </v-row>
</template>

<script>
export default {
    name: 'LayoutBento',
    
    components: {
        HarmonyCard: () => import('@/components/partials/harmony/HarmonyCard.vue'),
    },

    props: {
        cards: {
            type: Object,
            required: true
        },
        settings: {
            type: Object,
            required: true
        },
        isEditor: {
            type: Boolean,
            default: false
        },
        userName: {
            type: String,
            default: ''
        },
        backendUrl: {
            type: String,
            default: 'https://backend.harmony.fan/storage'
        },
        incompleteConfigurations: {
            type: Array,
            default: () => []
        },
        shouldShowWppEmail: {
            type: Boolean,
            default: false
        },
        socialItems: {
            type: Array,
            default: () => []
        }
    },

    computed: {
        allCards() {
            return Object.entries(this.cards)
                .map(([key, value]) => ({
                    key,
                    value,
                    number: parseInt(key.replace('card', '')),
                    size: value.size || 'medium',
                    position: value.position || 'left'
                }))
                .sort((a, b) => a.number - b.number);
        }
    },

    methods: {
        getBentoItemClass(index) {
            const classes = ['bento-item'];
            const card = this.allCards[index];
            
            // Mapear tamaños al grid Bento
            if (card.value.size === 'small') {
                classes.push('bento-item-small'); // 2 columnas, altura 130px
            } else if (card.value.size === 'large') {
                classes.push('bento-item-large'); // 2 columnas, altura 503px
            } else {
                classes.push('bento-item-medium'); // 1 columna, altura 180px (default)
            }
            
            return classes.join(' ');
        },

        getBentoSocialsClass() {
            const classes = ['bento-item', 'bento-socials'];
            
            if (this.socialItems.length > 5) {
                classes.push('bento-socials-large');
            }
            
            return classes.join(' ');
        }
    }
}
</script>

<style scoped>
.bento-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    width: 100%;
    max-width: 564px;
    margin: 0 auto;
    padding: 0 16px;
}

/* Small cards → Ocupan todo el ancho (2 columnas) pero mantienen su altura pequeña (130px) */
.bento-item-small {
    grid-column: span 2;
}

/* Medium cards → Ocupan 1 columna (mitad del ancho) con altura 180px */
.bento-item-medium {
    grid-column: span 1;
}

/* Large cards → Ocupan todo el ancho (2 columnas) con altura grande (503px) */
.bento-item-large {
    grid-column: span 2;
    height: 320px !important;
}

/* Estilos para socials */
.bento-socials {
    background: white;
    border-radius: 16px;
    padding: 12px;
    min-height: 80px;
    box-shadow: #00000061 0px 1px 6px 1.3px;
}

.bento-socials-large {
    grid-column: span 2;
}

/* Estilos para WhatsApp/Email */

/* Botón para agregar tarjeta */
.bento-add-card {
    background: #FFFFFF;
    cursor: pointer;
    border-radius: 16px;
    min-height: 130px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: #00000061 0px 1px 6px 1.3px;
}

.bento-add-card:hover {
    background: #f9f9f9;
    border-color: #8e84c0;
}

.add-card-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.add-card-text {
    color: #C9C9C9;
    font-size: 14px;
    font-weight: 500;
    margin: 0;
}

/* Responsive Design */
@media (max-width: 600px) {
    .bento-container {
        grid-template-columns: 1fr;
        gap: 12px;
        padding: 0 12px;
    }

    .bento-item-large,
    .bento-item-full-width,
    .bento-socials-large,
    .bento-wpp-email {
        grid-column: span 1;
    }
}
</style>